import { createContext } from "react";

import {
  captureEvent,
  identifyUser,
  resetUser,
  setAnalyticsGroups,
} from "./posthog";

export const AnalyticsContext = createContext({
  captureEvent,
  identifyUser,
  resetUser,
  setAnalyticsGroups,
});
